'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _invariant = require('nanotools/lib/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _get2 = require('nanotools/lib/get');

var _get3 = _interopRequireDefault(_get2);

var _iteratePrototypeChain = require('nanotools/lib/iteratePrototypeChain');

var _iteratePrototypeChain2 = _interopRequireDefault(_iteratePrototypeChain);

var _createSubject = require('observable-utils/lib/createSubject');

var _createSubject2 = _interopRequireDefault(_createSubject);

var _getObservableFrom = require('observable-utils/lib/getObservableFrom');

var _getObservableFrom2 = _interopRequireDefault(_getObservableFrom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReduxComponent = function () {
  function ReduxComponent() {
    var _this = this;

    (0, _classCallCheck3.default)(this, ReduxComponent);

    this.reducer = this.reducer.bind(this);
    this._subject = (0, _createSubject2.default)();

    // Event ordering: child components always get events before parents
    this.getSubject().subscribe({
      next: function next(state) {
        return _this.__notifyChildren(state);
      }
    });
  }

  (0, _createClass3.default)(ReduxComponent, [{
    key: 'reducer',
    value: function reducer(state, action) {
      if (state === void 0) {
        return null;
      } else {
        return state;
      }
    }
  }, {
    key: 'getSubject',
    value: function getSubject() {
      return this._subject;
    }

    // Backwards compatibility with internal API callers.

  }, {
    key: '__getSubject',
    value: function __getSubject() {
      return this._subject;
    }
  }, {
    key: '__notifyChildren',
    value: function __notifyChildren() {}
  }, {
    key: 'isMounted',
    value: function isMounted() {
      return !!this.__mounted;
    }
  }, {
    key: '__willMount',
    value: function __willMount(store) {
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var parentComponent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var i, len, stringPath, verb, verbs;
      if (process.env.NODE_ENV !== 'production') {
        (0, _invariant2.default)(store != null && store.dispatch && store.subscribe && store.getState && store.replaceReducer, 'redux-component of type ' + this.displayName + ' was mounted without a proper Store object. Redux components may only be mounted to valid redux stores.');
        (0, _invariant2.default)(!this.__mounted, 'redux-component of type ' + this.displayName + ' was multiply mounted. This can indicate a cycle in your component graph, which is illegal. Make sure each instance is only used once in your tree. If you wish to use a component in multiple places, construct additional instances. This mounting was at [' + path + ']. The previous mounting was at [' + this.path + '].');
      }

      // Demographics
      this.store = store;
      this.parentComponent = parentComponent;
      this.path = path;
      // Scope verbs
      if (verbs = this.__getMagicallyBoundKeys('verbs')) {
        stringPath = this.path.join('.');
        for (i = 0, len = verbs.length; i < len; i++) {
          verb = verbs[i];
          this[verb] = stringPath + ':' + verb;
        }
      }
      // Component at root of a tree or subtree gets a direct connection to the store.
      if (!parentComponent) {
        this._subject.subscription = (0, _getObservableFrom2.default)(this.store).subscribe(this._subject);
      }
      // Lifecycle
      if (typeof this.componentWillMount === "function") {
        this.componentWillMount();
      }
    }
  }, {
    key: '__didMount',
    value: function __didMount() {
      this.__mounted = true;
      if (typeof this.componentDidMount === "function") {
        this.componentDidMount();
      }
    }
  }, {
    key: '__willUnmount',
    value: function __willUnmount() {
      var ref;
      if (process.env.NODE_ENV !== 'production') {
        (0, _invariant2.default)(this.__mounted, 'redux-component of type ' + this.displayName + ' was unmounted when not mounted. This can indicate an issue in a dynamic reducer component such as redux-components-map.');
      }
      if (typeof this.componentWillUnmount === "function") {
        this.componentWillUnmount();
      }
      if ((ref = this._subject.subscription) != null) {
        ref.unsubscribe();
      }
      delete this._subject.subscription;
      delete this.store;
      delete this.path;
      delete this.parentComponent;
      delete this.__mounted;
    }
  }, {
    key: '__getMagicallyBoundKeys',
    value: function __getMagicallyBoundKeys(type) {
      var result;
      result = [];
      (0, _iteratePrototypeChain2.default)(this, function (proto) {
        var ref;
        return result = result.concat(((ref = proto.constructor) != null ? ref[type] : void 0) || []);
      });
      return result;
    }
  }, {
    key: 'state',
    get: function get() {
      if (this.store != null) {
        return (0, _get3.default)(this.store.getState(), this.path);
      } else {
        return undefined;
      }
    }
  }, {
    key: 'displayName',
    get: function get() {
      var ref, ref1;
      return ((ref = (0, _getPrototypeOf2.default)(this)) != null ? (ref1 = ref.constructor) != null ? ref1.name : void 0 : void 0) || '(unknown)';
    }
  }]);
  return ReduxComponent;
}();

exports.default = ReduxComponent;